<script lang="ts">
  import { getTextColorAndPrimaryVariants } from "app/utils/colors";
  import Image from "$components/+blocks/Image/Image.svelte";
  import { tailwindSizeToPixels } from "app/utils/tailwind";

  export let label: string = "";
  export let backgroundColor: string = "";
  export let mainImage: string | null = null;
  export let borderColor: string = "";
  export let size: string = "size-4";
  export let radius: string = "rounded-md";
  export let wrapperClasses: string = "";
  export let textSize: string = "text-md";
  export let cropPosition: "smart" | null = "smart";

  let textColor: string | undefined = undefined;
  if (!mainImage && backgroundColor) {
    textColor = getTextColorAndPrimaryVariants(backgroundColor).textColor;
  }

  // Use a multiplier of 5 to allow the browser to download slightly higher quality images; 4 (default) would be too precise
  let sizes = tailwindSizeToPixels(size, 5);
</script>

<div
  class="avatar shrink-0 overflow-hidden {size} {wrapperClasses} {radius}"
  style:border-color={borderColor}
>
  {#if mainImage}
    <Image
      src={mainImage}
      alt=""
      sizes={sizes || undefined}
      objectFit="object-contain"
      {cropPosition}
    />
  {:else if label}
    <span
      class="flex h-full items-center justify-center font-semibold text-neutral-600 uppercase dark:text-neutral-300 {textSize}"
      style:background={backgroundColor}
      style:color={textColor}
    >
      {label}
    </span>
  {/if}
</div>
